import React from 'react';
import ReactJson from 'react-json-view';
import { Snackbar, Alert } from '@mui/material';

const PayloadViewer = ({ data, collapsed = 1, name = "payload", enableClipboard = true, onFieldSelect }) => {
  const [snackOpen, setSnackOpen] = React.useState(false);
  const [copiedPath, setCopiedPath] = React.useState('');

  const buildJsonPath = (namespace) => {
    if (!namespace || namespace.length === 0) return '$';
    return '$.' + namespace.join('.');
  };

  const handleSelect = (select) => {
    const path = buildJsonPath(select.namespace);
    const fullPath = select.name ? `${path}.${select.name}` : path;
    navigator.clipboard.writeText(fullPath);
    setCopiedPath(fullPath);
    setSnackOpen(true);
    if (onFieldSelect) onFieldSelect(fullPath);
  };

  let parsedData = data;
  if (typeof data === 'string') {
    try { parsedData = JSON.parse(data); } catch { parsedData = {}; }
  }

  return (
    <>
      <ReactJson
        src={parsedData || {}}
        name={name}
        collapsed={collapsed}
        enableClipboard={enableClipboard}
        displayDataTypes={false}
        displayObjectSize={true}
        theme="rjv-default"
        style={{
          padding: '12px',
          borderRadius: '8px',
          border: '1px solid #e0e0e0',
          maxHeight: '400px',
          overflow: 'auto',
          fontSize: '13px',
        }}
        onSelect={handleSelect}
      />
      <Snackbar open={snackOpen} autoHideDuration={2000} onClose={() => setSnackOpen(false)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
        <Alert severity="info" onClose={() => setSnackOpen(false)}>JSONPath copiado: {copiedPath}</Alert>
      </Snackbar>
    </>
  );
};

export default PayloadViewer;
